/* eslint-disable */
var icon = require('vue-svgicon')
icon.register({
  'action': {
    width: 150,
    height: 150,
    viewBox: '0 0 150 150',
    data: '<path pid="0" d="M108.188 68.82c-.48-1.113-1.84-1.727-3.813-1.727H81.996c-.574 0-1.042-.203-1.316-.574-.273-.37-.328-.879-.156-1.43l9.11-29.238c.827-2.652.929-4.433.296-5.289-.27-.37-.66-.562-1.133-.562-1.039 0-2.476.973-4.265 2.89L43.157 77.214c-1.352 1.446-1.828 2.856-1.344 3.97.48 1.113 1.84 1.726 3.816 1.726h22.38c.574 0 1.042.203 1.316.574.273.371.328.879.156 1.43l-9.11 29.238c-.828 2.652-.925 4.437-.296 5.293.27.363.66.558 1.133.558 1.039 0 2.476-.972 4.265-2.89l41.38-44.32c1.339-1.45 1.82-2.86 1.335-3.973z" _fill="#C4FFF9" fill-rule="nonzero"/>'
  }
})
